import {
	getAllInvestorData,
	revokeInvestmentWorkflow,
	softDeleteInvestmentWorkflow,
} from '@dealstack/frontend/shared/dataExchange/services/god.service';
import { useMutation, useQuery } from '@tanstack/react-query';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { logger } from '@dealstack/frontend/shared/mechanism/logger/logger';
import { useParams } from 'react-router-dom';
import { useDSToast } from '@dealstack/frontend/shared/mechanism/toast/useDSToast';

export const useTransactionsActions = () => {
	const toastAPI = useDSToast();
	const { investorId } = useParams();

	const getInvestorDataRequest = useQuery({
		queryKey: [
			formatUnicorn(API_PATHS.GODMODE_INVESTOR_USERID_GET, { userId: investorId || '' }),
		],
		queryFn: ({ signal }) =>
			getAllInvestorData(
				formatUnicorn(API_PATHS.GODMODE_INVESTOR_USERID_GET, {
					userId: investorId || '',
				}),
				signal
			),
		meta: { suppressErrorToast: true },
	});

	const revokeInvestmentWorkflowRequest = useMutation({
		mutationFn: revokeInvestmentWorkflow,

		onSuccess: async () => {
			toastAPI.success({});
			await getInvestorDataRequest.refetch();
		},

		onError: (error) => {
			toastAPI.error({});
			logger.error(error);
		},
	});

	const softDeleteInvestmentWorkflowRequest = useMutation({
		mutationFn: softDeleteInvestmentWorkflow,

		onSuccess: async () => {
			toastAPI.success({ message: 'Soft deleted InvestmentWorkflow' });
			await getInvestorDataRequest.refetch();
		},

		onError: (error) => {
			toastAPI.error({});
			logger.error(error);
		},
	});

	return {
		revokeInvestmentWorkflowRequest,
		softDeleteInvestmentWorkflowRequest,
	};
};
